import Image from "next/image";
import RedactText from "../optout-general-components/redacttext";

interface ThreatCardProps {
  title: string;
  description: string;
  imagePath: string;
}

function ThreatCard({ title, description, imagePath }: ThreatCardProps) {
  return (
    <div className={"w-[292px] h-[454px] rounded overflow-hidden shadow-lg bg-brand-slate"}>
      <div className="flex justify-start align-middle mt-8 ml-8">
        <Image
          src={require(`/public/images/aiOptOut/common/${imagePath}`)}
          alt={imagePath}
          className=""
          width={40}
          height={40}
          priority
        />
      </div>
      <div className="flex justify-start align-middle mt-6 ml-8">
        <RedactText color="text-redactWhite font-bold" size="text-[21px]" text={title} />
      </div>
      <div className="flex justify-start align-middle mt-3 ml-8 w-60 ">
        <RedactText color="text-gray-300 font-normal" size="text-[15px]" text={description} />
      </div>
    </div>
  );
}

export default ThreatCard;
